<template>
  <div class="overlay">
    <div class="loading">
      <div class="lds-heart"><div></div></div>
      <p> loading... </p>
      <!-- <p>
        ... please wait while loading <br />
        ... espera un momento por favor <br />
        ... attendez s'il vous plait <br />
        ... お待ちください <br />
        ... 请稍候 <br />
        ارجوك انتظر... <br />

      </p> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingHeart'
}
</script>
<style lang="scss">
.overlay {
  position: fixed;
  z-index: 88888;
  top: 0;
  left: 0;
  right:0;
  bottom: 0;
  background: white;
  opacity: .9;
}

.loading {
  position: absolute;
  z-index: 9999999;
  top: 50%;
  left: 50%;
  margin-top: -40px;
  margin-left: -40px;
}

.lds-heart {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: rotate(45deg);
  transform-origin: 40px 40px;
}
.lds-heart div {
  top: 32px;
  left: 32px;
  position: absolute;
  width: 32px;
  height: 32px;
  background:red;
  animation: lds-heart 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}
.lds-heart div:after,
.lds-heart div:before {
  content: " ";
  position: absolute;
  display: block;
  width: 32px;
  height: 32px;
  background: red;
}
.lds-heart div:before {
  left: -24px;
  border-radius: 50% 0 0 50%;
}
.lds-heart div:after {
  top: -24px;
  border-radius: 50% 50% 0 0;
}
@keyframes lds-heart {
  0% {
    transform: scale(0.95);
  }
  5% {
    transform: scale(1.1);
  }
  39% {
    transform: scale(0.85);
  }
  45% {
    transform: scale(1);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>
